import {Field, Formik} from 'formik';
import * as React from 'react';
import {useState} from 'react';
import PasswordChecklist from 'react-password-checklist';
import {Link, useLocation} from 'react-router-dom';
import * as Yup from 'yup';
import {Button} from '~/components/Button';
import {InputType} from '~/components/Controls/Input';
import {Form, InputField, IntentText, NoteMessage} from '~/components/Form';
import {InfoWrapper} from '~/components/Layout';
import {Progress} from '~/components/Progress';
import {Intent} from '~/lib/intent';
import {renewPassword} from '~/modules/Profile/api';
import style from './../../index.module.scss';

interface IRenewParams {
    password: string;
    passwordConfirm: string;
}
export const passwordSchema = Yup.string()
    .matches(/[A-Za-z]/, 'The characters in the password must be Latin (e.g. A-Z, a-z).')
    .matches(/^\S+$/, 'The password must not contain spaces.')
    .required('Required');

const RenewSchema = Yup.object().shape<IRenewParams>({
    password: passwordSchema,
    passwordConfirm: passwordSchema
});

const renewParamsDefault: IRenewParams = {
    password: '',
    passwordConfirm: ''
};

export const RenewView = () => {
    const location = useLocation();
    let url = new URLSearchParams(location.search);
    const [passwordUpdated, setPasswordUpdated] = useState<boolean>(false);
    const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false);

    return <InfoWrapper links={[
        <Link key='sign-in' to='/sign-in'>Sign In</Link>
    ]}>
        <Formik
            initialValues={renewParamsDefault}
            validationSchema={RenewSchema}
            onSubmit={(values, actions) => {
                if (values.password !== values.passwordConfirm) {
                    actions.setStatus('Passwords are not equal');
                    actions.setSubmitting(false);
                } else {
                    renewPassword(url.get('email'), parseInt(url.get('exp'), 10), url.get('signature'), values.password)
                        .then(() => setPasswordUpdated(true))
                        .catch(error => {
                            actions.setStatus(error.response.data.message);
                            actions.setSubmitting(false);
                        });
                }
            }}
        >
            {(form) => <Form>
                {passwordUpdated ? <div className={style.formSimple}>
                    Password was updated successfully
                </div> : <>
                    <div className={style.formSimple}>
                        {form.status &&
                            <IntentText className={style.formStatus} intent={Intent.DANGER}>{form.status}</IntentText>}
                        Password requirements:
                        <div className={style.passwordCheck}>
                            <PasswordChecklist
                                rules={['minLength', 'lowercase', 'capital', 'number', 'specialChar', 'match']}
                                minLength={8}
                                value={form.values.password}
                                valueAgain={form.values.passwordConfirm}
                                onChange={isValid => setIsPasswordValid(isValid)}
                            />
                        </div>
                        <Field name='password'
                            label='Password'
                            options={{
                                type: InputType.PASSWORD,
                                passwordToggle: true,
                                placeholder: 'Password',
                                leftIcon: <i className='fa fa-key'/>,
                                disabled: form.isSubmitting,
                            }}
                            className={style.simpleField}
                            component={InputField}
                        />
                        <Field name='passwordConfirm'
                            label='Password confirm'
                            options={{
                                type: InputType.PASSWORD,
                                passwordToggle: true,
                                leftIcon: <i className='fa fa-key'/>,
                                placeholder: 'Password confirm',
                                disabled: form.isSubmitting,
                            }}
                            className={style.simpleField}
                            component={InputField}
                        />
                    </div>
                    <div>
                        <Button type='submit' disabled={form.isSubmitting || !isPasswordValid} intent={Intent.PRIMARY}>{form.isSubmitting ?
                            <Progress/> :
                            'Recover'}</Button>
                    </div>
                </>}
            </Form>}
        </Formik>
    </InfoWrapper>;
};
